// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"Select_wrapperComponent__kuZto","isSpecial":"Select_isSpecial__RLL-p"};